
const initialState = {
  open: false,
  lastJobPayload: {},
};

export default function importFilters(state = initialState, { type, payload }) {
  switch (type) {
    case 'genAI_openImportFilters':
      return {
        ...state,
        open: true,
      };
    case 'genAI_closeImportFilters':
      return {
        ...state,
        open: false,
      };
    case 'genAI_ImportFilters_checkStatus_SUCCESS':
      return {
        ...state,
        lastJobPayload: payload,
      };
    default:
      return state;
  }
}
